






import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class BaseTable extends Vue {
  @Prop({ required: false, default: "2" })
  cols!: "1" | "credentials" | "popular-prefixes";

  @Prop({ required: false, default: false })
  slim!: boolean;

  @Prop({ required: false, default: false })
  code!: boolean;

  get colsClass() {
    return `cols-${this.cols}`;
  }

  get slimClass() {
    return this.slim ? "slim" : "";
  }
}
